'use strict';

const vertexVariables = [
    'varying vec2 hoUv;'
].join('\n');

const vertexMain = [
    'vec4 rp = modelMatrix * vec4( position, 1.0 );',
    'float size = 512.0;',
    'float scale = 1.0/1024.0;',
    'hoUv = vec2((rp.x+size)*scale,(rp.z+size)*scale);',
    'gl_Position = projectionMatrix * viewMatrix * rp; '
].join('\n');

const fragmentVariables = [
    'uniform sampler2D hmap;',
    'uniform sampler2D overlayMap;',
    'varying vec2 hoUv;',
].join('\n');

const fragmentMap = [
    'vec4 sampledDiffuseColor = texture2D( map, vMapUv );',
    'vec4 overlay = texture2D(overlayMap, hoUv);',
    'if (overlay.r != 0.0) {',
    'diffuseColor *= overlay;',
    '} else {',
    'diffuseColor *= sampledDiffuseColor;}'
].join('\n');

const fragmentMain = [
    'float h = texture2D(hmap, hoUv).r;',
    'if (h != 0.0) {',
    'discard;}'
].join('\n');


export class Hmap {
    static texture = null;
    static overlay = null;

    static upgradeMaterial(material) {
        if (!Hmap.texture && !Hmap.overlay) return;

        material.onBeforeCompile = (shader) => Hmap.upgradeShader(shader);
    }

    static upgradeShader(shader) {
        if (!Hmap.texture && !Hmap.overlay) return;

        shader.uniforms.hmap = {
            value: Hmap.texture
        };
        
        shader.uniforms.overlayMap = {
            value: Hmap.overlay
        };

        shader.vertexShader = shader.vertexShader.replace(
            '#include <clipping_planes_pars_vertex>',
            [
                '#include <clipping_planes_pars_vertex>',
                vertexVariables
            ].join( '\n' )
        );

        shader.vertexShader = shader.vertexShader.replace(
            '#include <project_vertex>',
            [
                '#include <project_vertex>',
                vertexMain
            ].join( '\n' )
        );

        shader.fragmentShader = shader.fragmentShader.replace(
            '#include <clipping_planes_pars_fragment>',
            [
                '#include <clipping_planes_pars_fragment>',
                fragmentVariables
            ].join( '\n' )
        );
    
        shader.fragmentShader = shader.fragmentShader.replace(
            '#include <map_fragment>',
            fragmentMap
        );

        shader.fragmentShader = shader.fragmentShader.replace(
            '#include <tonemapping_fragment>',
            [
                fragmentMain,
                '#include <tonemapping_fragment>'
            ].join( '\n' )
        );
    }
}
